import { IDecimalInternal, IUlidInternal } from "./interfaces";

export const isIUlid = (value: unknown): value is IUlidInternal =>
    typeof value === "object" &&
    value !== null &&
    "high" in value &&
    "low" in value &&
    typeof value.high === "bigint" &&
    typeof value.low === "bigint";

export const isIDecimal = (value: unknown): value is IDecimalInternal =>
    typeof value === "object" &&
    value !== null &&
    "neg_precision" in value &&
    "base" in value &&
    typeof value.neg_precision === "number" &&
    typeof value.base === "bigint";
